'use strict';

angular.module('atex.dam').directive('damTextColor', function ($compile) {
  return {
    restrict: 'AE',
    replace: true,

    scope: {
      aspect: '=',
      fixedWidth: '='
    },

    link: function (scope, element) {

      scope.colors = function () {
        scope.color = scope.aspect.data.status.color;

        if (!atex.dam.AngularUtils.isHexColor(scope.color)) {
          scope.color = atex.dam.AngularUtils.getHex(scope.color);
        }

        scope.textColor = atex.dam.AngularUtils.textColorOnBgColor(scope.color);
      };

      scope.generate = function () {
        if(scope.color && scope.textColor) {
          var html =
            "<span class='label " + (scope.fixedWidth ? "label-list" : "") + "' style='background-color:{{color}}; color:{{textColor}}; border: 1px solid gray' " +
            "title='{{aspect.data.comment}}'>" +
            "{{aspect.data.status.name}}" +
            "</span>";

          var linkFn = $compile(html);
          var content = linkFn(scope);
          element.replaceWith(content);
        }
      };

      scope.$watch('aspect.data.status.color', function (newValue, oldValue) {
        if (newValue) {
          scope.colors();
        }

        scope.generate();
      });
    }
  };
});
